/* eslint-disable import/order */
import '@/store'
import '@/utils/vee-validate'
import * as additionalNews from './modules/additionalNews'
import calendar from './modules/calendar'
import * as criteo from './modules/criteo'
import openOfferLinkInNewWindow from './modules/customizations/openOfferLinkInNewWindow'
import * as datalayer from './modules/datalayer'
import * as flightSchedule from './modules/flightSchedule'
import * as footerComponent from './modules/footer'
import * as hotelMap from './modules/hotelMap'
import * as interactiveMap from './modules/interactiveMap'
import * as newsletterComponent from './modules/newsletter'
import * as newsletterAutoconfirmation from './modules/newsletter/autoconfirmation'
import * as offersList from './modules/offersList'
import * as rodoForm from './modules/rodo'
import * as rodoBookingForm from './modules/rodoBooking'
import * as rodoConfirmation from './modules/rodoConfirmation'
import * as salespointsMap from './modules/salespointsMap'
import * as searchForm from './modules/searchForm'
import * as similarOffers from './modules/similarOffers'
import * as topOffers from './modules/topOffers'
import weatherWidget from './modules/weather-widget'

import * as events from '@/events'

// Booking page components
import * as bookingAdditionalServices from '@/modules/bookingAdditionalServices'
import * as bookingClientForm from '@/modules/bookingClientForm'
import * as bookingHeader from '@/modules/bookingHeader'
import * as bookingHotelSummary from '@/modules/bookingHotelSummary'
import * as bookingPaymentPicker from '@/modules/bookingPayment'
import * as bookingRodoForm from '@/modules/bookingRodoForm'
import * as bookingSessionBar from '@/modules/bookingSessionBar'
import * as bookingSidebar from '@/modules/bookingSidebar'
import * as bookingSummary from '@/modules/bookingSummary'
import * as reservationDeduplicator from '@/modules/customizations/reservationDeduplicator'
import * as componentException from '@/modules/exception'
import * as survey from '@/modules/survey'

const $ = require('jquery')
require('masonry-layout')

window.jQuery = $

const { BREAKPOINT, SELECTOR } = require('./modules/api')
const appGrecosPageOrder = require('./modules/appGrecosPageOrder')
const blogSlider = require('./modules/blogSlider')
const bookingWidget = require('./modules/bookingWidget')
const breadcrumb = require('./modules/breadcrumb')
const campaignTimer = require('./modules/campaignTimer')
const { checkInternetExplorerVersion } = require('./modules/checkInternetExplorerVersion')
const dolphinClub = require('./modules/dolphinClub')
const dynamicContentComponent = require('./modules/dynamicContentComponent')
const formBookingWidgetAJAX = require('./modules/formBookingWidgetAJAX')
const formFiltersOffers = require('./modules/formFiltersOffers')
const formMainOfferSearch = require('./modules/formMainOfferSearch')
const { Loader, /*isFluidLayoutPage, */ isMobileView, isPageWithNewSearcher } = require('./modules/globals')
const goUp = require('./modules/goUp')
const gridTiles = require('./modules/gridTiles')
const headerComponent = require('./modules/header')
const infoSection = require('./modules/infoSection')
const isMobile = require('./modules/isMobile')
const listingOptions = require('./modules/listingOptions')
const mainSearch = require('./modules/mainSearch')
const mainSlider = require('./modules/mainSlider')
const modals = require('./modules/modals')
const offerWidgets = require('./modules/offerWidgets')
const { ratingScroll } = require('./modules/ratingScroll')
const searchComponent = require('./modules/search')
const searchFilter = require('./modules/searchFilter')
const { showMobileOffersTable } = require('./modules/showMobileOffersTable')
const smoothScroll = require('./modules/smoothScroll')
const socialButtons = require('./modules/socialButtons')
const stickyOffer = require('./modules/stickyOffer')
const Tooltips = require('./modules/tooltips')

// =========================================================================

let self
const $window = $(window)
const windowDimensions = {
  width: $window.width(),
  height: $window.height(),
}

/**
 * [appGrecos - Main app object]
 * @type {Object}
 */
const appGrecos = {
  init () {
    self = this

    smoothScroll()
    Tooltips.init()

    $('.force-first-letter-uppercase').upperCaseFirstLetter()

    self.actionsForEachPage()

    if (isPageWithNewSearcher()) {
      searchForm.init()
    }

    if (!isMobileView() && !isPageWithNewSearcher()) {
      events.formsListUpdated.subscribe(() => {
        // Initialize all calendars
        for (let i = 0; i < document.forms.length; i++) {
          calendar.init(document.forms[i])
        }
      })
    }

    if (isMobileView() && !isPageWithNewSearcher()) {
      showMobileOffersTable.init(events, calendar)
    }

    datalayer.init()
    criteo.init()
    rodoForm.init()
    flightSchedule.init()
    rodoConfirmation.init()
    rodoBookingForm.init()
    interactiveMap.init()
    hotelMap.init()
    salespointsMap.init()

    topOffers.init()
    similarOffers.init()

    /* #search_code */
    if (!isMobileView() && !isPageWithNewSearcher()) {
      formMainOfferSearch.simple()
      formMainOfferSearch.advanced()
      formMainOfferSearch.common()
    }
    if (!isPageWithNewSearcher()) {
      formFiltersOffers.init()
    }
    /* #eof_search_code */
    formBookingWidgetAJAX.init()

    newsletterAutoconfirmation.init()
    newsletterComponent.init()

    headerComponent.init()
    headerComponent.handleMenu()
    searchComponent.autocomplete()
    footerComponent.init()

    mainSlider.init()
    mainSlider.addSwipe()
    mainSlider.toggleAutoplay()

    gridTiles.init()
    gridTiles.responsive()
    self.offerTeaserMobileClick()

    bookingWidget.init()

    breadcrumb.init()
    goUp.init()

    listingOptions.Sort()
    offersList.init()

    infoSection.init()

    blogSlider.init()
    blogSlider.attachButtons()
    blogSlider.changeDisplayMode()
    blogSlider.articlesLinks()

    modals.createModalsPlaceholder()
    modals.modalShow()
    modals.modalGallery()

    ratingScroll()
    dolphinClub.init()

    stickyOffer.init()

    self.loadTabs()

    self.blackAndWhite()

    self.onResize()

    additionalNews.init()

    campaignTimer.init()
    dynamicContentComponent.init()

    openOfferLinkInNewWindow.init()
    weatherWidget.init()

    reservationDeduplicator.init()
    
    survey.init()

    bookingHeader.init()
    bookingSessionBar.init()
    bookingHotelSummary.init()
    bookingClientForm.init()
    bookingSidebar.init()
    bookingSummary.init()
    bookingAdditionalServices.init()
    bookingPaymentPicker.init()
    bookingRodoForm.init()

    componentException.init()

    offerWidgets.init()

    events.formsListUpdated()
    events.appInitialized()
  },

  onResize (callback) {
    let resizeTimer = null
    $window.resize(function() {
      if ($window.width() != windowDimensions.width) {

        clearTimeout(resizeTimer)
        resizeTimer = setTimeout(function() {
          blogSlider.changeDisplayMode()
          infoSection.init()
        }, 150)

        windowDimensions.width = window.innerWidth
        windowDimensions.height = window.innerHeight

        appGrecos.actionsForEachPage()

        $(document.body).trigger('sticky_kit:recalc')

        mainSlider.addSwipe()
        mainSlider.toggleAutoplay()

        gridTiles.responsive()
        
        /* #search_code */
        if (!isMobileView() && !isPageWithNewSearcher()) {
          mainSearch.init()
        }
        /* #eof_search_code */

        appGrecos.offerTeaserMobileClick()
        stickyOffer.init()

        appGrecosPageOrder.orderOfferMarginTop() 
        appGrecosPageOrder.orderParticipantFormMobile() 
        appGrecosPageOrder.orderParticipantMobileStyles() 
        appGrecosPageOrder.orderClearVoucherValue() 
        appGrecosPageOrder.orderFixedHeader()

        additionalNews.init()

        /* #search_code */
        const offerSearchSimpleForm = $('.offer-search-simple').not('.form-filters-offers')
        if (!isMobileView() && !isPageWithNewSearcher()) {
          offerSearchSimpleForm.find('> div[class*=" custom-select-"]').show()
          offerSearchSimpleForm.find('> .form-submit-border').show()
        }

        if (!isMobileView() && !isPageWithNewSearcher()) {
          SELECTOR.MAIN_SEARCH_SIMPLE.find('.close-form').hide()
          SELECTOR.MAIN_SEARCH_ADVANCED.find('.close-form').hide()
        }
        /* #eof_search_code */
        
        callback && callback(window.innerWidth, window.innerHeight)
      }
    })
  },

  // =========================================================================
  // Specyfic action for each page
  // =========================================================================
  actionsForEachPage () {
    if (SELECTOR.BODY.hasClass('page--home')) {
      if ($('#campaignTimer').length && window.innerWidth < BREAKPOINT.TABLET) {
        headerComponent.logo(false)
      } else {
        headerComponent.logo(true)
      }
    } else if (SELECTOR.BODY.hasClass('page--listing')) {

      if (window.innerWidth > BREAKPOINT.DESKTOP) {
        headerComponent.logo(true)
        listingOptions.ChangeTypeView()
      } else {
        headerComponent.logo(false)

      }

      if (window.innerWidth <= BREAKPOINT.DESKTOP) {
        if (SELECTOR.STAGE.hasClass('fixed')) {
          SELECTOR.STAGE.removeClass('fixed')
        }
      }

    } else if (SELECTOR.BODY.hasClass('page--offer')) {
      headerComponent.logo(true)
    }
  },

  // =========================================================================
  // Loading gallery list
  // =========================================================================
  loadTabs () {
    $('.offer-tabs__nav__element.offer-link--hotel').addClass('active')

    $('.offer-tabs__nav__element').find('a').not('a[href=#all-offers]').on('click', function(e) {
      e.preventDefault()
      e.stopPropagation()
      const eTarget = $(e.target)
      const dataTargetTab = eTarget.parents('.offer-tabs__nav__element').data('target')

      eTarget.parents('.offer-tabs__nav').find('.active').removeClass('active')
      eTarget.parents('.offer-tabs__nav__element').addClass('active')

      $('.tab-content > div[class^="tab--"]').hide()
      $('.tab-content').find(`.${dataTargetTab}`).fadeIn()

      events.hotelNavigationUpdated()
    })
  },

  // =========================================================================
  // TODO: ujednolicenie wszystkich hover
  // =========================================================================
  hoverMobileClick () {
    $('.hoverTouch').on('touchstart', function(e) {
      if ($(this).hasClass('touched')) {
        $(this).removeClass('touched')
      } else {
        $(this).addClass('touched')
        e.preventDefault()
      }
    })
  },

  offerTeaserMobileClick () {
    if (isMobile.any() || window.innerWidth < BREAKPOINT.TABLET) {
      $('.grid-item').not('.grid-item.grid-item--s2column').on('touchstart', function(event) {
        if ($(this).hasClass('touched')) {
          //Ma checked - 2 klik
          $(this).removeClass('touched')
          $(this).find('.grid-item__overlay').css('opacity', '0')
          $(this).find('.grid-item__main-content .grid-item__headline').css('opacity', '1')
        } else {
          //Nie ma checked - 1 klik
          $(this).addClass('touched')
          event.preventDefault()
          $(this).find('.grid-item__overlay').css('opacity', '1')
          $(this).find('.grid-item__main-content .grid-item__headline').css('opacity', '0')

        }
      })

      $('.teaser').on('touchstart', function(event) {
        if ($(this).hasClass('touched')) {
          $(this).find('.teaser-hover').hide()
        } else {
          $(this).addClass('touched')
          event.preventDefault()
          $(this).find('.teaser-hover').show()
        }
      })
    }
  },

  // =========================================================================
  // Set grayscale for images
  // =========================================================================
  blackAndWhite () {
    if (checkInternetExplorerVersion() >= 10) {
      $('.grayscale').each(function() {
        const el = $(this)
        el.css({ position: 'absolute' })
          .wrap('<div class="img_wrapper" style="display: inline-block; vertical-align: top">')
          .clone()
          .addClass('img_grayscale')
          .css({ position: 'absolute', 'z-index': '5', opacity: '0' })
          .insertBefore(el)
          .queue(function() {
            const el = $(this)
            el.parent().css({ width: this.width, height: this.height })
            el.dequeue()
          })
        this.src = grayscale(this.src)
      })

      $('.grayscale').hover(
        function() {
          $(this).parent().find('img:first').stop().animate({ opacity: 1 }, 200)
        },
        function() {
          $('.img_grayscale').stop().animate({ opacity: 0 }, 200)
        }
      )
    }

    function grayscale (src) {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      const imgObj = new Image()
      imgObj.src = src
      canvas.width = imgObj.width
      canvas.height = imgObj.height
      ctx.drawImage(imgObj, 0, 0)
      try {
        const imgPixels = ctx.getImageData(0, 0, canvas.width, canvas.height)
        for (let y = 0; y < imgPixels.height; y++) {
          for (let x = 0; x < imgPixels.width; x++) {
            const i = (y * 4) * imgPixels.width + x * 4
            const avg = (imgPixels.data[i] + imgPixels.data[i + 1] + imgPixels.data[i + 2]) / 3
            imgPixels.data[i] = avg
            imgPixels.data[i + 1] = avg
            imgPixels.data[i + 2] = avg
          }
        }
        ctx.putImageData(imgPixels, 0, 0, 0, 0, imgPixels.width, imgPixels.height)
        return canvas.toDataURL()
      } catch (err) {
        log.error(err)
        return null
      }
    }

    // $('.grayscale').attr('src', grayscale($('.grayscale').attr('src')));
  },
}

// ------------------------------------
// Exists function
// ------------------------------------
$.fn.exists = function() { return this.length > 0 }

window.appGrecos = appGrecos

// =====================================
// Init
// =====================================

$(function() {
  /* #search_code */
  if (!isMobileView() && !isPageWithNewSearcher()) {
    $('.main-search > .container:eq(0)').append(Loader('small', 'white', false))
  }
  /* #eof_search_code */

  appGrecos.init()

  if (SELECTOR.BODY.hasClass('page--order')) {
    appGrecosPageOrder.init()
  }

  /* #search_code */
  if (!isMobileView() && !isPageWithNewSearcher()) {
    setTimeout(function() {
      if (SELECTOR.BODY.hasClass('page--home')) {
        $('.main-search > .container > .row').fadeIn()
      }
      $('.main-search > .container > form').fadeIn()
      $('.main-search > .container').find('.loader__inner').remove()
    }, 2000)

    $(window).on('resize', function() {
      if (SELECTOR.BODY.hasClass('page--home')) {
        $('.main-search > .container > .row').show()
      }
      $('.main-search > .container > form').show()
    })
  }
  /* #eof_search_code */
})

$(window).on('load', function() {
  appGrecos.actionsForEachPage()
  /* #search_code */
  if (!isMobileView() && !isPageWithNewSearcher()) {
    mainSearch.init()
  }
  /* #eof_search_code */

  appGrecos.actionsForEachPage()
  /* #search_code */
  if (!isMobileView() && !isPageWithNewSearcher()) {
    mainSearch.init()
  }
  /* #eof_search_code */

  if ($('.social-button').exists()) {
    $('.social-button').each(function(index, value) {
      socialButtons.init(value)
    })
  }
})

if (!isPageWithNewSearcher()) {
  $(document).ready(searchFilter.init)
}


// WEBPACK FOOTER //
// ./src/app.js